/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResocontoPastiClasseSezione } from './resoconto-pasti-classe-sezione';
import { PastiNonOrdinariStudenti } from './pasti-non-ordinari-studenti';
import { OrdinamentoScolastico } from './ordinamento-scolastico';


export interface ResocontoPastiStudenti { 
    intestazione_scuola?: string;
    ordinamento?: OrdinamentoScolastico;
    numero_pasti_ordinari?: number;
    pasti_non_ordinari?: Array<PastiNonOrdinariStudenti>;
    pasti_per_sezione_classe?: Array<ResocontoPastiClasseSezione>;
}



